import { useTranslation } from '@pancakeswap/localization'
import { useModal } from '@pancakeswap/uikit'
import { useExpertMode } from '@pancakeswap/utils/user'
import TransactionsModal from '@/components/App/Transactions/TransactionsModal'
import { useSwapHotTokenDisplay } from '@/hooks/useSwapHotTokenDisplay'
import { useAtom } from 'jotai'
import { memo, ReactElement, useCallback, useContext, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useRoutingSettingChanged } from '@/state/user/smartRouter'
import atomWithStorageWithErrorCatch from '@/utils/atomWithStorageWithErrorCatch'
import { BarChartIcon, ClockIcon, GearIcon, ReloadIcon } from '@radix-ui/react-icons'
import { SettingsMode } from '@/components/Menu/GlobalSettings/types'
import SettingsModal from '@/components/Menu/GlobalSettings/SettingsModal'
import { NotificationDot } from '@/components/ui/notification-dot'
import { SwapFeaturesContext } from '../SwapFeaturesContext'
import { SwapSettingsPopover } from '@/components/popovers/swap-settings'
import { Typography } from '@/components/ui/typography'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface Props {
  title: string | ReactElement
  subtitle: string
  noConfig?: boolean
  setIsChartDisplayed?: React.Dispatch<React.SetStateAction<boolean>>
  isChartDisplayed?: boolean
  hasAmount: boolean
  onRefreshPrice: () => void
}

//  disable this during the v3 campaign
const mobileShowOnceTokenHighlightAtom = atomWithStorageWithErrorCatch('pcs::mobileShowOnceTokenHighlightV2', true)

const CurrencyInputHeader: React.FC<React.PropsWithChildren<Props>> = memo(
  ({ subtitle, title, hasAmount, onRefreshPrice }) => {
    const { t } = useTranslation()
    const [mobileTooltipShowOnce, setMobileTooltipShowOnce] = useAtom(mobileShowOnceTokenHighlightAtom)
    const [mobileTooltipShow, setMobileTooltipShow] = useState(false)

    const { isChartSupported, isChartDisplayed, setIsChartDisplayed, isHotTokenSupported } =
      useContext(SwapFeaturesContext)
    const [expertMode] = useExpertMode()
    const [isRoutingSettingChange] = useRoutingSettingChanged()
    const toggleChartDisplayed = () => {
      setIsChartDisplayed?.((currentIsChartDisplayed) => !currentIsChartDisplayed)
    }
    const [onPresentTransactionsModal] = useModal(<TransactionsModal />)
    const [onPresentSettingsModal] = useModal(<SettingsModal mode={SettingsMode.SWAP_LIQUIDITY} />)
    const [isSwapHotTokenDisplay, setIsSwapHotTokenDisplay] = useSwapHotTokenDisplay()

    const mobileTooltipClickOutside = useCallback(() => {
      setMobileTooltipShow(false)
    }, [])

    useEffect(() => {
      if (isMobile && !mobileTooltipShowOnce) {
        setMobileTooltipShow(true)
        setMobileTooltipShowOnce(true)
      }
    }, [mobileTooltipShowOnce, setMobileTooltipShowOnce])

    useEffect(() => {
      document.body.addEventListener('click', mobileTooltipClickOutside)
      return () => {
        document.body.removeEventListener('click', mobileTooltipClickOutside)
      }
    }, [mobileTooltipClickOutside])

    const titleContent = (
      <div className="flex items-center justify-between w-full">
        <Tabs>
          <TabsList className={'bg-transparent flex gap-4'}>
            <TabsTrigger value={'swap'}>
              <Typography variant={'small'}>Swap</Typography>
            </TabsTrigger>
            <TabsTrigger value={'send'} className={'hidden'}>
              <Typography variant={'small'}>Send</Typography>
            </TabsTrigger>
          </TabsList>
        </Tabs>
        <div className={'flex items-center gap-2'}>
          {isChartSupported && (
            <button
              type={'button'}
              onClick={() => {
                if (!isChartDisplayed && isSwapHotTokenDisplay) {
                  setIsSwapHotTokenDisplay(false)
                }
                toggleChartDisplayed()
              }}
              data-dd-action-name="Price chart button"
            >
              {isChartDisplayed ? <BarChartIcon /> : <BarChartIcon />}
            </button>
          )}
          <NotificationDot display={expertMode || isRoutingSettingChange}>
            <SwapSettingsPopover />
            {/* <GearIcon className={'w-5 h-5 icon'} onClick={onPresentSettingsModal} /> */}
          </NotificationDot>
          {/* <ClockIcon className={'w-5 h-5 icon'} onClick={onPresentTransactionsModal} /> */}
          {/* <ReloadIcon className={'w-5 h-5 icon'} onClick={onRefreshPrice} /> */}
        </div>
      </div>
    )

    return <div className={'mb-4'}>{titleContent}</div>
  },
)

export default CurrencyInputHeader
